<template>
  <Layout :main-classes="isEmbed ? 'p-0' : ''">
    <template #sidebar="{ topbarNavigation }">
      <Sidenav :topbar-navigation="topbarNavigation" :navigation="navigation" />
    </template>

    <template v-if="!isEmbed" #contextual-nav>
      <ContextualNav
        v-if="tabs.length > 0"
        class="mx-auto max-w-content-container pb-5"
        :tabs="tabs"
      />
    </template>
    <slot />
  </Layout>
</template>

<script setup lang="ts">
import Layout from '~/components/Layout.vue'
import ContextualNav from '~/components/layout/ContextualNav.vue'
import Sidenav from '~/components/layout/Sidenav.vue'
import { useNavigationStore } from '~/stores/navigation'

const navigationStore = useNavigationStore()
const { navigation, tabs } = storeToRefs(navigationStore)

const route = useRoute()

const isEmbed = computed(() => route.meta.isEmbed)
</script>
